import { getCsrfToken } from 'query';
import { tokenizeRoute } from 'query/routes';

export const CREATE_STUDY_MERGE = '/reviews/{review_id}/study_merges';

export type StudyMergeRequest = {
  studyIds: number[];
  studyIdSelected: number;
};

export type StudyMergeResponse = {
  review_id: number;
  wasMerged: boolean;
  mergedStudyId: string | null;
  studiesCount: number;
  collection: {
    id: number;
    title: string;
    study_id: string;
  }[];
};

/**
 * Complete a study merge by selecting which study to use as the primary.
 */
export const completeStudyMerge = async (
  reviewId: string,
  studyIds: number[],
  studyIdSelected: number
): Promise<StudyMergeResponse> => {
  const route = tokenizeRoute(CREATE_STUDY_MERGE, { review_id: reviewId });

  const response = await fetch(route.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({ studyIds, studyIdSelected }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to merge studies');
  }

  return response.json();
};
